import WDentalCard from './WDentalCard.vue'

export default WDentalCard
